import { useEffect, useState } from 'react';
import api from '../../services/api';

export const money = minor => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 }).format(minor / 100);
export const documentLabel = value => ({identificacion_oficial:'Identificación oficial', comprobante_domicilio:'Comprobante de domicilio', fotografia:'Fotografía', acta_constitutiva:'Acta constitutiva', constancia_fiscal:'Constancia fiscal', poder_representante:'Poder del representante'})[value] || String(value || '').replaceAll('_',' ');
export const paymentLabel = value => ({paid:'Pago confirmado', pending:'Pendiente de confirmación', creating:'Preparando pago', failed:'Pago fallido', expired:'Sesión vencida', refunded:'Reembolsado', review:'Requiere conciliación'})[value] || 'Requiere revisión';

export function useCommercialCatalog() {
  const [catalog, setCatalog] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    api.get('/public/commercial-catalog').then(({ data }) => {
      if (!Array.isArray(data.plans) || data.plans.length !== 3) throw new Error('Catálogo incompleto');
      if (active) setCatalog(data);
    }).catch(() => { if (active) setError('No pudimos consultar la disponibilidad. Intenta de nuevo más tarde.'); });
    return () => { active = false; };
  }, []);
  return { catalog, error };
}

export function rememberInvitation() {
  const query = new URLSearchParams(window.location.search);
  const ref = query.get('ref');
  // First valid-shaped code wins. Server validates the account, never trusts this storage.
  if (ref && /^[A-Za-z0-9_-]{12,32}$/.test(ref) && !sessionStorage.getItem('upim_commercial_ref')) sessionStorage.setItem('upim_commercial_ref', ref);
  return sessionStorage.getItem('upim_commercial_ref') || '';
}

export function trackView(event) {
  // Existing authenticated analytics only. Server checks consent. No cookie or external tracker.
  if (!localStorage.getItem('upim_token')) return;
  const key = `upim-view-${event}`;
  let occurrence = sessionStorage.getItem(key);
  if (!occurrence) { occurrence = crypto.randomUUID(); sessionStorage.setItem(key, occurrence); }
  api.post('/auth/commercial-event', { event, occurrence }).catch(() => {});
}
